import { qs, qsAll } from '../utils/domHelpers.js';

export function initCarousel(carouselParentSelector) {
  const parent = qs(carouselParentSelector);
  if (!parent) return;

  const list = qs('.inline__product-list', parent);
  const prevBtn = qs('.carousel__button--prev', parent);
  const nextBtn = qs('.carousel__button--next', parent);
  const pagination = qs('.pagination__summary', parent.parentElement);

  const ITEM_WIDTH = 300;
  const GUTTER = window.innerWidth * 0.0531; // 5.31vw

  if (list) {
    list.scrollLeft = 0;
  }

  const getItemsPerPage = () => {
    const containerWidth = list.offsetWidth;
    return Math.floor(containerWidth / (ITEM_WIDTH + GUTTER));
  };

  const getTotalPages = () => {
    const totalItems = list.children.length;
    return Math.floor(totalItems / getItemsPerPage());
  };

  const updatePagination = () => {
    if (!pagination) return;
    const pageWidth = (ITEM_WIDTH + GUTTER) * getItemsPerPage();
    const currentPage = Math.ceil(list.scrollLeft / pageWidth) + 1;
    const totalPages = getTotalPages();
    const maxScrollLeft = list.scrollWidth - list.clientWidth - 1; // a little buffer
    if (pagination) {
      if (list.scrollLeft >= maxScrollLeft) {
        pagination.textContent = `Page ${totalPages} of ${totalPages}`;
      } else {
        pagination.textContent = `Page ${currentPage} of ${totalPages}`;
      }
    }

    if (pagination) {
      pagination.setAttribute('data-total-pages', totalPages);
    }

    if (prevBtn) {
      prevBtn.disabled = list.scrollLeft <= 0;
    }

    if (nextBtn) {
      nextBtn.disabled = list.scrollLeft >= maxScrollLeft;
    }
  };

  const scrollByPage = (direction = 1) => {
    const pageWidth = (ITEM_WIDTH + GUTTER) * getItemsPerPage();
    list.scrollBy({ left: direction * pageWidth * 0.8, behavior: 'smooth' });
  };

  const handleWheel = (e) => {
    //   if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
    //     list.scrollLeft += e.deltaX;
    //   } else {
    //     list.scrollLeft += e.deltaY;
    //   }
    updatePagination();
  };

  prevBtn?.addEventListener('click', () => scrollByPage(-1));
  nextBtn?.addEventListener('click', () => scrollByPage(1));
  list.addEventListener('scroll', () => {
    window.requestAnimationFrame(updatePagination);
  });
  list.addEventListener('wheel', handleWheel, { passive: true });

  // Swipe support
  // let startX = 0;
  // list.addEventListener('touchstart', (e) => {
  //   startX = e.touches[0].clientX;
  // });
  // list.addEventListener('touchmove', (e) => {
  //   const dx = e.touches[0].clientX - startX;
  //   list.scrollLeft -= dx;
  //   startX = e.touches[0].clientX;
  // });

  const observer = new MutationObserver(() => {
    updatePagination();
  });

  observer.observe(list, { childList: true, subtree: false });

  updatePagination();
}